import {getCachedTableStateSlice} from 'src/hooks/common-data-service/cached-table';

import type {CachedTableStateSelector} from 'src/hooks/common-data-service/cached-table/typedef';

export const excelPluginUsageReportsStateSlice = getCachedTableStateSlice<
    undefined,
    undefined,
    undefined
>('excelPluginUsageReportsState', undefined, {currentPage: 1, pageSize: 10});

export const excelPluginUsageReportsStateActions = excelPluginUsageReportsStateSlice.actions;
export const excelPluginUsageReportsStateSelector: CachedTableStateSelector<
    undefined,
    undefined,
    undefined
> = state => state.accountPage.tabs.licenseAndFeatures.reports.excelPluginUsageReport.state;
